import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  try {
    // If icon is directly passed as a component
    if (icon) {
      return React.createElement(icon, props);
    }
    
    // If name is passed as a string
    if (name) {
      const IconComponent = FiIcons[`Fi${name}`];
      if (IconComponent) {
        return React.createElement(IconComponent, props);
      }
    }
  } catch (error) {
    console.error("Icon render error:", error);
  }

  // Fallback
  return <FiAlertTriangle {...props} />;
};

export default SafeIcon;